import { HttpErrorResponse } from '@angular/common/http';
import { Component, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export interface IErrorModalParameters {
  error: HttpErrorResponse;
}

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ErrorModalComponent {
  public parameters: IErrorModalParameters | undefined;

  constructor(private _activeModal: NgbActiveModal) {}

  public dismiss(): void {
    this._activeModal.dismiss();
  }
}
